import { render, staticRenderFns } from "./del-subuser.vue?vue&type=template&id=194cbf2c&"
import script from "./del-subuser.vue?vue&type=script&lang=js&"
export * from "./del-subuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports